import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface EventBasicFieldsProps {
  title: string;
  eventType: string;
  teamId: string;
  userTeams: Array<{ team_id: number; team_name: string }>;
  onTitleChange: (value: string) => void;
  onEventTypeChange: (value: string) => void;
  onTeamChange: (value: string) => void;
}

export const EventBasicFields: React.FC<EventBasicFieldsProps> = ({
  title,
  eventType,
  teamId,
  userTeams,
  onTitleChange,
  onEventTypeChange,
  onTeamChange,
}) => {
  return (
    <>
      <div>
        <Label htmlFor="title">Event Title</Label>
        <Input
          id="title"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          className="bg-gray-900 border-gray-700 text-white"
          required
        />
      </div>

      <div>
        <Label htmlFor="event_type">Event Type</Label>
        <Select value={eventType} onValueChange={onEventTypeChange}>
          <SelectTrigger className="bg-gray-900 border-gray-700 text-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-gray-900 border-gray-700 text-white">
            <SelectItem value="practice" className="text-white hover:bg-gray-800">Practice</SelectItem>
            <SelectItem value="meeting" className="text-white hover:bg-gray-800">Meeting</SelectItem>
            <SelectItem value="training" className="text-white hover:bg-gray-800">Training</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor="team_id">Team (Optional)</Label>
        <Select value={teamId} onValueChange={onTeamChange}>
          <SelectTrigger className="bg-gray-900 border-gray-700 text-white">
            <SelectValue placeholder="Select a team" />
          </SelectTrigger>
          <SelectContent className="bg-gray-900 border-gray-700 text-white">
            {userTeams.map((team) => (
              <SelectItem key={team.team_id} value={team.team_id.toString()} className="text-white hover:bg-gray-800">
                {team.team_name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
};